// One phrasing for a course window, shared by the catalog, the course page
// and the teacher list.
//
// Course dates are ALL optional (see CLAUDE.md → "Course dates"): a course can
// have only a start, only an end, both, or neither. The old rendering was a
// bare range with an ellipsis standing in for whichever half was missing —
// "2026-07-01 → …" — which reads as truncated or broken data rather than as
// "this one has no end date". Each case gets its own sentence instead.
//
// Returns null when there are no dates at all; the caller decides whether that
// means "always open" (a list with a dates column must fill the cell) or
// nothing at all (a card simply omits the line).
export function coursePeriod(t, start, end) {
  if (start && end) return t('courses.period', { start, end })
  if (start) return t('courses.period_from', { start })
  if (end) return t('courses.period_until', { end })
  return null
}
